module.exports = __webpack_public_path__ + "img/recovery.03cbad45.svg";